// apps/spa/src/components/reminders/EmptyState.tsx
// Centered shield mark (with a breathing gold glow) + primary CTA. fadeUp entrance.
import { Link } from 'react-router';
import { motion, useReducedMotion } from 'motion/react';
import { Button } from '@/components/ui/button';
import { fadeUp } from '@/lib/motion';

export function EmptyState() {
  const reduce = useReducedMotion();
  return (
    <motion.div
      variants={fadeUp}
      initial={reduce ? false : 'hidden'}
      animate="show"
      className="flex flex-col items-center justify-center gap-4 py-16 text-center"
    >
      <span className="relative inline-flex">
        <span
          aria-hidden="true"
          className="absolute inset-0 -z-10 rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(212,175,55,.25), transparent 70%)',
            animation: reduce ? undefined : 'ringBreath 4s ease-in-out infinite',
          }}
        />
        <svg aria-hidden="true" viewBox="0 0 64 64" className="size-16" role="img">
          <path d="M32 4 L56 14 V32 C56 46 44 56 32 60 C20 56 8 46 8 32 V14 Z" fill="none" stroke="#d4af37" strokeWidth="2" />
          <path d="M32 18 V46 M22 28 H42" stroke="#d4af37" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </span>
      <h2 className="font-display text-2xl">No reminders yet</h2>
      <p className="text-muted-foreground max-w-md text-sm">
        Create your first scheduled post for BASTN.
      </p>
      <Link to="/reminders/new">
        <Button>+ New reminder</Button>
      </Link>
    </motion.div>
  );
}
